import { getCustomerFiles } from 'api/offers';
import Translations from 'App.translations';
import { Actions as GlobalActions } from 'pages/_store/global/actions';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

interface FetchFilesArgs {
  offerId: string;
  customerId: number;
  fileTypes: string[];
}

export const useFetchFiles = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const call = async ({ offerId, customerId, fileTypes }: FetchFilesArgs) => {
    try {
      return await getCustomerFiles({
        customerId,
        offerId,
        fileTypes,
      });
    } catch {
      dispatch(
        GlobalActions.sendNotification({
          message: formatMessage(Translations.AppErrorFetchingFiles),
          variant: 'error',
          anchorOrigin: {
            horizontal: 'center',
            vertical: 'top',
          },
        })
      );
    }
  };

  return call;
};
